<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <svg
      :class="{'is-active':isActive}"
      class="hamburger"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
    >
      <path fill="#B5B5B5" d="M408.0128 442.0096h480c4.4032 0 7.9872-3.584 7.9872-7.9872V378.0096a8.0384 8.0384 0 0 0-7.9872-7.9872H408.0128a8.0384 8.0384 0 0 0-8.0384 7.9872v56.0128c0 4.352 3.584 7.9872 8.0384 7.9872z m-8.0384 203.9808c0 4.4032 3.584 7.9872 8.0384 7.9872h480c4.4032 0 7.9872-3.584 7.9872-7.9872v-56.0128a8.0384 8.0384 0 0 0-7.9872-7.9872H408.0128a8.0384 8.0384 0 0 0-8.0384 7.9872v56.0128z m504.0128-485.9904H120.0128a8.0384 8.0384 0 0 0-7.9872 7.9872v56.0128c0 4.4032 3.584 7.9872 7.9872 7.9872h783.9744c4.4032 0 8.0384-3.584 8.0384-7.9872V167.9872a8.0384 8.0384 0 0 0-8.0384-7.9872z m0 632.0128H120.0128a8.0384 8.0384 0 0 0-7.9872 7.9872v56.0128c0 4.4032 3.584 7.9872 7.9872 7.9872h783.9744c4.4032 0 8.0384-3.584 8.0384-7.9872v-56.0128a8.0384 8.0384 0 0 0-8.0384-7.9872zM115.4048 518.912l156.3136 123.0848c5.7856 4.608 14.336 0.512 14.336-6.912V388.9152a8.8576 8.8576 0 0 0-14.336-6.912L115.4048 505.088a8.704 8.704 0 0 0 0 13.824z" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.hamburger.is-active {
  transform: rotate(180deg);
}
</style>
